jQuery(document).ready(function($) {
    
	$('.header__nav-button').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('body').toggleClass('--mobile-nav-active');
	});

	$('#header__nav a').click(function() {
		if($('.header__nav-button').is(":visible")) {
			$('.header__nav-button').trigger('click');
		}
	});

	$(window).scroll(function() {

		let currentScrollPos = document.documentElement.scrollTop + 110;

		$('#header__nav a[href^="/#"]').each(function() {
			var anchor = $(this).attr('href').replace('/', '');


			if($(anchor).length) {
				var anchorTopPos = $(anchor).offset().top;
				var anchorBottomPos = $(anchor).offset().top + $(anchor).outerHeight();
				if(currentScrollPos >= anchorTopPos && currentScrollPos < anchorBottomPos && !$(anchor).hasClass('--scroll-active')) { // If below element add class
					$('#header__nav a.--scroll-active').removeClass('--scroll-active');
					$(this).addClass('--scroll-active');
					return false;
				} else if(currentScrollPos < anchorTopPos && $(this).hasClass('--scroll-active')) { // If above element, always remove class and add to previous
					$(this).removeClass('--scroll-active');
					$(this).parent('li').prev().find('a').addClass('--scroll-active');
				}
			}

		});


	});
 
});
